import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useDialogFormStore } from '@/components/dialog/form.store';
import { useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { CustomerWithdrawal } from '@/services/withdrawals/customerWithdrawals.types';
import { useSearch } from '@tanstack/react-router';
import React from 'react';
import { getColumns } from './Column';

export function WithdrawalCustomer({
  data,
  pagination,
  isLoading = false,
}: {
  data: CustomerWithdrawal[];
  pagination: Pagination;
  isLoading: boolean;
}) {
  const { onOpen } = useDialogFormStore();
  const { t } = useDynamicLocale();

  const { activeTab } = useSearch({ from: '/(app)/configuration-management/withdrawals-setup/' });
  const columns = React.useMemo(() => getColumns(onOpen, activeTab, t), [onOpen, activeTab, t]);
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );

  const { table } = useDataTable({
    data,
    columns,
    pageCount: pageCount,
    initialState: {
      sorting: [{ id: 'withdrawalId', desc: true }],
    },
    meta: {
      title: t('configurationManagement.withdrawalSetup.customer.title'),
      totalPage: pagination.totalItems,
      actionKey: 'onAddNew',
      action: () => {},
      loading: isLoading,
      actionDisabled: true,
    },
    getRowId: (originalRow) => String(originalRow.withdrawalId),
    shallow: false,
    clearOnDefault: true,
  });
  return (
    <>
      <DataTable table={table} className="rounded-t-none">
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
